
var app = angular.module('directives.applePay', []);

require('./directives/applePay.js');
require('./stylesheets/applePay.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/applePay/index.js
 ** module id = 121
 ** module chunks = 1
 **/